<template>
	<div class="servo-system-list">
		<div class="servo-system-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Servo System</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>

				<div class="d-2">
					<h3> Servo System Main Features</h3>
					<ul>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								The Xhorse servo system,  with high speed in the industry and high torque in a compact lightweight body;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								We're committed to providing a compact, fast and easy-to-use Servo system to meet the needs of changeble
								times;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">High-speed response, high-precision positioning for quick and
								accurate movement;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Realize 3kHz frequency response to improve productivity and enable high-speed operations;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Resonance Suppression function, it is widely used in high-performance servo drivers.this function can promptly
								measure the the frequencies and depth of vibration. With the configured notch filters, the servo system can
								massively  reduce noise and vibration caused by equipment resonance and respond quickly.
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Friction torque compensation, This function reduces the effect of machine related friction and improves
								responsiveness to keep the prompt response.
							</div>
						</li>
					</ul>
				</div>

				<img :src="solution_image_02" alt="Xhorse"/>

				<div class="d-3">
					<p>
						We adopted multiple instruments and test methods to ensure that the Servo System can perform well under various working conditions. First, we adopted Chroma 62050H-600 Programmable DC Power Supply to simulate various voltage fluctuations on the busbar to test the voltage immunity of our products; Secondly, we adopted YOKOGAWA WT5000 Precision Power Analyzer to evaluate the performance of our products such as efficiency, power factor, voltage and current harmonics. And we adopted YOKOGAWA DL850E ScopeCorder to monitor the status of the product during the long-term operation; Besides, we built an evaluation system composed of a two-motor platform supplemented by high-precision torque, speed sensors, and various professional instruments to analyze and optimize the performance of our products under various load conditions.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_servo_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_servo_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
	.ll {
		width: calc(100% - .625rem);
	}

	.dot {
		width: .625rem;
	}

	.d-3 > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.d-2 > ul > li {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.d-2 > ul {
		width: 100%;
		height: 22.125rem;
		border: none;
	}

	.d-2 > h3 {
		font-family: "Open SB";
		text-align: left;
		margin-bottom: 2.75rem;
	}

	.d-2, .d-3 {
		width: 100%;
		height: 22.125rem;
		/*margin-bottom: 2.75rem;*/
	}

	.list > img {
		width: 54.5rem;
		margin-bottom: 2.75rem;
		margin-top: 2.75rem;

	}

	.list {
		width: 54.5rem;
		height: 82.375rem;
		margin-left: 7rem;
		border: none;
	}

	.servo-system-con {
		width: 61.5rem;
		height: 86.6875rem;
		margin-left: 0;
		border: none;
	}

	.servo-system-list {
		width: 100%;
		height: 86.6875rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-servo-system.vue